import { R } from '@/features/programs/resources/ProgramsResources.resx';
import { VideoTypeIcon } from '@/components/Icons';
import { Utils } from '@/shared/Utils';
import { ActiveConsultationDto } from '@/features/programs/model/types';

export const UpcomingConsultation = ({
    upcomingConsultation,
}: {
    upcomingConsultation: ActiveConsultationDto;
}) => {
    const formattedDateTime = Utils.uppercaseFirst(
        Utils.formatRelativeDateTime(
            upcomingConsultation.Consultation?.ScheduledOn,
        ),
    );

    return (
        <div className="content-grid-narrow z-10 mt-4 lg:-mt-16">
            <div className="mb-2 font-medium text-gray-800">
                {R.YourNextConsultation}
            </div>
            <div className="rounded-2xl border border-gray-400 bg-white px-4 py-6 md:px-6">
                <div className="flex h-12 flex-row items-center">
                    <VideoTypeIcon />
                    <div className="ml-4 flex flex-col justify-center gap-1 text-left">
                        <div className="text-lg leading-tight font-bold">
                            {formattedDateTime}
                        </div>
                        <div className="text-sm leading-tight">
                            {upcomingConsultation.CaregiverName}
                        </div>
                    </div>
                </div>

                <a
                    href={`/consultations/details/${upcomingConsultation.Consultation?.UID}`}
                >
                    <button className="btn btn-primary mt-4 w-full">
                        {R.GoToUpcomingConsultation}
                    </button>
                </a>
            </div>
        </div>
    );
};
